<template>
  <DataCollapse
    :isLastChild="!item.children || item.children.length === 0"
    :style="{ marginLeft: indent + 'px' }"
    :isAccordion="true"
    class="py-2"
  >
    <template #title>
      <div class="flex justify-end items-center gap-8">
        <BasicButton v-if="hasSelect" @click="(e) => add(e, item)">{{
          $t('labels.add')
        }}</BasicButton>
        {{ locale === 'fr' ? item.nameFr : item.nameEn }}
        <span v-if="added === item.id" class="text-green-400">{{
          $t('labels.added')
        }}</span>
      </div>
    </template>
    <div v-if="item.children">
      <ListAccordion
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :indent="indent + 20"
        :has-select="hasSelect"
        @add="(item) => emit('add', item)"
      />
    </div>
  </DataCollapse>
</template>

<script lang="ts" setup>
const { locale, t } = useI18n()

const added = ref()
const emit = defineEmits(['add'])

const add = (e, item) => {
  emit('add', item)
  e.stopPropagation()
  added.value = item.id
  setTimeout(() => {
    added.value = undefined
  }, 1500)
}
defineProps({
  item: {
    type: Object,
    required: true,
  },
  indent: {
    type: Number,
    default: 0,
  },
  hasSelect: {
    type: Boolean,
    default: false,
  },
})
</script>
